import { render, staticRenderFns } from "./candidates.vue?vue&type=template&id=9c9804aa"
import script from "./candidates.vue?vue&type=script&lang=js"
export * from "./candidates.vue?vue&type=script&lang=js"
import style0 from "./candidates.vue?vue&type=style&index=0&id=9c9804aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports